import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../app/config";
import { ILogin } from "./loginModel";
import { ErrorToast } from "../../components/toast/Toasts";
import { axiosApiInstance } from "../../app/axios";

const initialState = {
  loading: false,
  googleLoading: false,
  error: "",
  data: null,
  loginDetails: {
    UserID: localStorage.getItem("UserID") || "",
    Name: localStorage.getItem("Name") || "",
    FullName: localStorage.getItem("FullName") || "",
    EmailID: localStorage.getItem("EmailID") || "",
    UserTypeID: localStorage.getItem("UserTypeID") || "",
    UserType: localStorage.getItem("UserType") || "",
    UserImage: localStorage.getItem("UserImage") || "",
    IsCustomized: localStorage.getItem("IsCustomized") || "NO",
    isWebsite: localStorage.getItem("isWebsite") || "NO",
    IsMasterUser: localStorage.getItem("IsMasterUser") || "NO",
    Company_GUID: localStorage.getItem("Company_GUID") || "",
  },
};

export const employeeLogin = createAsyncThunk(
  "UserLogin/UserLogin",
  async (data: ILogin) => {
    try {
      const response = await axios.post(`${API_URL}/UserLogin/UserLogin`, data);
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error login:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const userLoginWithGoogle = createAsyncThunk(
  "Google/LoginWithGoogleToken",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Google/LoginWithGoogleToken`,
        payload,
      );
      // SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Login user:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(employeeLogin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      employeeLogin.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.data = action.payload;
        state.loading = false;
        state.error = "";
        const result = action.payload;
        state.loginDetails.UserID = result.ID;
        state.loginDetails.Name = result.Name;
        state.loginDetails.FullName = result.UserName || result.FullName || "";
        state.loginDetails.EmailID = result.EmailID;
        state.loginDetails.UserTypeID = result.UserTypeID;
        state.loginDetails.UserType = result.UserType || "User";
        state.loginDetails.UserImage = result.UserImage;
        state.loginDetails.IsCustomized = result.IsCustomized || "NO";
        state.loginDetails.isWebsite = result?.Website || "NO";
        state.loginDetails.IsMasterUser = result?.IsMasterUser || "NO";
        state.loginDetails.Company_GUID = result?.Company_GUID || "";

        if (result?.Token) {
          localStorage.setItem("Token", result?.Token);
          localStorage.setItem("RefreshToken", result?.RefreshToken);
          localStorage.setItem("UserID", result?.ID);
          localStorage.setItem("Name", result?.Name);
          localStorage.setItem("FullName", result?.UserName || "AI XEM");
          localStorage.setItem("EmailID", result?.EmailID);
          localStorage.setItem("IsUser", result?.IsUser);
          localStorage.setItem("UserTypeID", result?.UserTypeID);
          localStorage.setItem("UserType", result?.UserType || "User");
          localStorage.setItem("UserImage", result?.UserImage);
          localStorage.setItem("IsCustomized", result?.IsCustomized || "NO");
          localStorage.setItem("isWebsite", result?.Website || "NO");
          localStorage.setItem("IsMasterUser", result?.IsMasterUser || "NO");
          localStorage.setItem("Company_GUID", result?.Company_GUID || "");
          localStorage.setItem(
            "UserRightsAssign",
            JSON.stringify(result?.UserRightsAssign),
          );
        }
      },
    );
    builder.addCase(employeeLogin.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(userLoginWithGoogle.pending, (state) => {
      state.googleLoading = true;
      state.error = "";
    });
    builder.addCase(userLoginWithGoogle.fulfilled, (state) => {
      state.googleLoading = false;
    });
    builder.addCase(userLoginWithGoogle.rejected, (state, action) => {
      state.googleLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default loginSlice.reducer;
